import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { merge, Subscription } from "rxjs";
import { SlottedPipeService } from "src/app/services/slotted-pipe/slotted-pipe.service";
import { DCSlottedLengthRequest } from "../../models/slotted-pipe";
import { SlottedService } from "../../services/slotted.service";
import { Groupings } from "../../../shared/enums/groupings.enum";
import { Patterns } from "../../../shared/enums/patterns.enum";


@Component({
  selector: "app-slotted-lengths",
  templateUrl: "./slotted-lengths.component.html",
  styleUrls: ["./slotted-lengths.component.css"],
})
export class SlottedLengthComponent implements OnInit {
  @Input() fgSlottedPipe: UntypedFormGroup;

  showDataCheck: boolean = false;
  refreshDataCheckData$: Subscription;

  constructor(
    private slottedService: SlottedService,
    private slottedPipeService: SlottedPipeService
  ) {}

  ngOnInit(): void {
    this.refreshDataCheckData$ =
      this.slottedService.refreshDataCheckData$.subscribe((refreshData) => {
        if (refreshData.section == "LENGTHS") this.dataCheck();
      });

    merge(
      this.fgSlottedPipe.get("fgType").valueChanges,
      this.fgSlottedPipe.get("fgLengths").valueChanges
    ).subscribe(() => {
      if (
        this.fgSlottedPipe.get("fgType").valid &&
        this.fgSlottedPipe.get("fgLengths").valid
      ) {
        this.showDataCheck = true;
      } else {
        this.showDataCheck = false;
      }
    });

    this.fgSlottedPipe.get("fgLengths").valueChanges.subscribe(() => {
      let LT = Number(
        String(
          this.fgSlottedPipe.get("fgLengths").get("pipeLengthLT").value
        ).replace(",", ".")
      );
      let LL1 = Number(
        String(
          this.fgSlottedPipe.get("fgLengths").get("freeDistanceToBoxLL1")
            .value
        ).replace(",", ".")
      );
      let LL2 = Number(
        String(
          this.fgSlottedPipe.get("fgLengths").get("freeDistanceToBoxLL2")
            .value
        ).replace(",", ".")
      );

      if (
        this.fgSlottedPipe.get("fgLengths").get("pipeLengthLT").value !=
          "" &&
        this.fgSlottedPipe.get("fgLengths").get("freeDistanceToBoxLL1")
          .value != "" &&
        this.fgSlottedPipe.get("fgLengths").get("freeDistanceToBoxLL2")
          .value != "" &&
        LT &&
        LL1 &&
        LL2 &&
        LT <= LL1 + LL2
      ) {
        setTimeout(() => {
          this.fgSlottedPipe.get("fgLengths").setErrors({ LTSum: true });
        }, 1);
      } else {
        this.fgSlottedPipe.get("fgLengths").setErrors(null);
      }
    });
  }

  dataCheck() {
    let dcSlottedLengthRequest: DCSlottedLengthRequest = {
      iLL1: this.fgSlottedPipe.get("fgLengths").get("freeDistanceToBoxLL1")
        .value,
      iLL2: this.fgSlottedPipe.get("fgLengths").get("freeDistanceToBoxLL2")
        .value,
      iPipeLengthLT: this.fgSlottedPipe.get("fgLengths").get("pipeLengthLT")
        .value,
      rdAligned:
        this.fgSlottedPipe?.get("fgType").get("pattern").value ===
        Patterns.Aligned,
      rdStaggered:
        this.fgSlottedPipe?.get("fgType").get("pattern").value ===
        Patterns.Staggered,
      rdGroupingGangs:
        this.fgSlottedPipe?.get("fgType").get("grouping").value ===
        Groupings.Gangs,
      rdGroupingSingle:
        this.fgSlottedPipe?.get("fgType").get("grouping").value ===
        Groupings.Single,
      rdNo: this.fgSlottedPipe?.get("fgType").get("groovesMachinedWithSaw")
        .value === false,
      rdYes: this.fgSlottedPipe?.get("fgType").get("groovesMachinedWithSaw")
        .value === true,
    };

    this.slottedPipeService
      .dataCheckSlottedLength(dcSlottedLengthRequest)
      .subscribe((data) => {
        let dataCheckData = [];

        if (data.results.Output.hasError)
          for (let key in data.results.Output.errors) {
            let errorData = {
              type: "ERROR",
              parent: data.results.Output.belongsTo,
              description: data.results.Output.errors[key].description,
              options: data.results.Output.errors[key].options,
            };

            for (let optionKey in data.results.Output.errors[key].options) {
              errorData.options.push(
                data.results.Output.errors[key].options[optionKey]
              );
            }

            dataCheckData.push(errorData);
          }

        if (data.results.Output.hasWarning)
          for (let key in data.results.Output.warnings) {
            let warningData = {
              type: "WARNING",
              parent: data.results.Output.belongsTo,
              description: data.results.Output.warnings[key].description,
              options: [],
            };

            for (let optionKey in data.results.Output.warnings[key].options) {
              warningData.options.push(
                data.results.Output.warnings[key].options[optionKey]
              );
            }

            dataCheckData.push(warningData);
          }

        this.slottedService.setDataCheckData(dataCheckData, "LENGTHS");
      });
  }

  ngOnDestroy(): void {
    this.refreshDataCheckData$.unsubscribe();
  }
}
